import { render, staticRenderFns } from "./EditCampaign.vue?vue&type=template&id=55b472de&scoped=true&"
import script from "./EditCampaign.vue?vue&type=script&lang=js&"
export * from "./EditCampaign.vue?vue&type=script&lang=js&"
import style0 from "./EditCampaign.vue?vue&type=style&index=0&id=55b472de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b472de",
  null
  
)

export default component.exports